// extracted by mini-css-extract-plugin
export default {"impressumContainer":"Impressum_impressumContainer__KWjlp","infoBox":"Impressum_infoBox__0LI-P"};